import React from "react";

import "./FmStepIcon.css";

interface IFmStepIconProps {
    icon: React.ReactNode;
    active: boolean;
    onClick?: () => void;
}

const FmStepIcon = ({ icon, active, onClick }: IFmStepIconProps) => {
    let isActive = { container: "", border: "" };

    if (active) {
        isActive = { container: "icon_container", border: "icon_border" };
    } else {
        isActive = {
            container: "icon_notActive_container",
            border: "icon_notActive_border",
        };
    }

    return (
        <div className={isActive.container}>
            <a
                className={isActive.border}
                href='/'
                onClick={(e) => {
                    e.preventDefault();
                    onClick && onClick();
                }}
            >
                {icon}
            </a>
        </div>
    );
};

export default FmStepIcon;
